import { Card } from "antd";
import { Button } from "../../components/ui-kit/Button";
import { FC, useCallback } from "react";

interface VacancListItemProps {
    title: string;
    url: string;
    description: string;
}

export const VacancyListItem: FC<VacancListItemProps> = ({
    title,
    url,
    description,
}: VacancListItemProps) => {
    const onSelect = useCallback(() => {
        window.open(url, '_self');
    }, [url]);
    return (
        <div className="flex flex-col gap-4 w-full max-w-2xl p-3 sm:pt-8 border bg-white border-gray-200 border-solid rounded-2xl box-border cursor-pointer hover:shadow-lg transition-shadow" onClick={onSelect}>
            <div className="px-2 sm:px-5 flex flex-col gap-4">
                <div className="text-2xl sm:text-3xl font-black">{title}</div>
                <div className="text-xl">{description}</div>
            </div>
            <div className="pt-3 flex sm:justify-end">
                <Button size="large" onClick={onSelect} className="!rounded-2xl w-full sm:w-auto">
                    Откликнуться
                </Button>
            </div>
        </div>
    );
}